exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".block-title[data-v-11bf6570]:after {\n  display: none;\n}\n", "", {"version":3,"sources":["/home/vsts/work/1/s/apps/client/landing/src/views/admin/reports/ReportsListView.vue"],"names":[],"mappings":"AAOA;EACI,cAAa;CAAA","file":"ReportsListView.vue?vue&type=style&index=0&id=11bf6570&scoped=true&lang=css&","sourcesContent":["@import \"../../../../../common/styles/user-variables\";\n@import \"../../../../../vendor/createx/styles/helpers\";\n@import \"~bootstrap/scss/functions\";\n@import \"~bootstrap/scss/variables\";\n@import \"~bootstrap/scss/mixins\";\n\n\n.block-title:after {\n    display: none;\n}\n"],"sourceRoot":""}]);

// exports
